import type { FC, ReactNode } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import { ExclamationCircle } from 'react-bootstrap-icons';
import './styles/styles.css';

interface ModalProps {
  show: boolean;
  handleClose: () => void;
  text?: string;
  title?: string;
  icon?: ReactNode;
  buttonText?: string;
}

export const ConfirmStepsWarningModal: FC<ModalProps> = ({
  show,
  handleClose,
  text,
  title,
  icon,
  buttonText = 'Ok',
}) => {
  const onClickSubmit = () => {
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="post-editor-modal modal-100w"
      backdrop="static"
      id="guest-portal"
      centered
    >
      <Modal.Header className="guest-modal-header ">
        <Modal.Title className="editor-title">
          {icon || <ExclamationCircle size={25} color="var(--warning-color, #ffce00)" />}{' '}
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="guest-modal-header">
        <Form>
          <Row>
            <Form.Text>{text}</Form.Text>
          </Row>
        </Form>
      </Modal.Body>

      <Container className="warning-modal-footer ">
        <Button className="save-button no-border-radius" onClick={onClickSubmit}>
          {buttonText}
        </Button>
      </Container>
    </Modal>
  );
};
